import { Chip, ChipProps, Stack } from "@mui/material";
import React, { ReactNode } from "react";

export const MetaListItem = (props: ChipProps) => (
  <Chip
    size="small"
    variant="outlined"
    sx={!props.variant ? { "&.MuiChip-root": { border: "none" } } : {}}
    {...props}
  />
);

export const MetaList = ({ children }: { children: ReactNode }) => {
  return (
    <Stack direction="row" alignItems="center" gap={1.5}>
      {children}
    </Stack>
  );
};
